import Typography from 'components/Typography/Typography'
import { Menu } from 'antd'
import { VendorsListMenuItems } from './constants'
import { TVendorsListMenuProps } from './types'
import { useMemo } from 'react'
import {
  ACTIONS,
  SUBJECTS,
  ability as commonAbility
} from '../../../../Permission'
import { useVendorsAbility } from '../../Providers'
import { useVendorsPagePopup } from '../../Providers/VendorsPagePopupProvider'

export const VendorsListMenu = ({ data }: TVendorsListMenuProps) => {
  const ability = useVendorsAbility()

  const { addToMyVendorsPopup, upgradeToFullAccessPopup } =
    useVendorsPagePopup()

  const canUpgrade = useMemo(
    () => ability.can('UPGRADE', 'VENDOR_PERMISSION'),
    [ability]
  )

  const canAddToMyVendors = commonAbility.can(ACTIONS.ADD, SUBJECTS.MY_VENDORS)

  const handleClick = (key: string) => {
    if (!data) return
    switch (key) {
      case 'upgrade':
        upgradeToFullAccessPopup.actions.open({ uuid: data.uuid })
        break
      case 'add_to_my_vendors':
        addToMyVendorsPopup.actions.open({ vendor: data })
        break
    }
  }

  const tabs = useMemo(() => {
    return VendorsListMenuItems.filter((item) => {
      if (item.key === 'upgrade') {
        return canUpgrade && data?.vendor_permission !== 'full_access'
      }

      if (item.key === 'add_to_my_vendors') {
        return canAddToMyVendors
      }

      return false
    })
  }, [canUpgrade, data?.vendor_permission, canAddToMyVendors])

  return (
    <>
      <Menu className="menu-items-wrapper actual-savings-menu">
        {tabs.map((i) => (
          <Menu.Item key={i.key} onClick={() => handleClick(i.key)}>
            <Typography.Body1>{i.label}</Typography.Body1>
          </Menu.Item>
        ))}
      </Menu>
    </>
  )
}
